import React from "react";
import moment from "moment";
import { formatPhoneNumber } from "../../lib/Formatter";

const headerStyle = () => {
  return { borderColor: "#a81933" };
};

const columnStyle = () => {
  return {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  };
};

export const ClassTypeEnum = {
  AllInstances: 163,
  Corporate: 164,
  NonCorporate: 165,
};

export const columns = [
  {
    dataField: "vendorName",
    text: "Vendor / Contractor",
    sort: true,
    headerStyle: headerStyle,
    style: columnStyle,
  },
  {
    dataField: "contactName",
    text: "Contact Name",
    sort: true,
    headerStyle: headerStyle,
    style: columnStyle,
  },
  {
    dataField: "contactPhone",
    text: "Contact Phone",
    sort: true,
    headerStyle: headerStyle,
    formatter: (_cell, row) => {
      return (
        <a href={`tel:${row.contactPhone}`} style={{ textDecoration: "none" }}>
          {formatPhoneNumber(row.contactPhone)}
        </a>
      );
    },
  },
  {
    dataField: "startDate",
    text: "Start Date",
    sort: true,
    headerStyle: headerStyle,
    formatter: (_cell, row) => {
      return moment(row.startDate).format("MM/DD/YYYY");
    },
  },
  {
    dataField: "expirationDate",
    text: "Expiration Date",
    sort: true,
    headerStyle: headerStyle,
    formatter: (_cell, row) => {
      const expiration = moment(row.expirationDate);
      const today = moment();
      const daysLeft = expiration.diff(today, "days");
      const formattedDate = expiration.format("MM/DD/YYYY");

      if (daysLeft <= 30) {
        return (
          <span style={{ color: "red" }}>
            {formattedDate}
            <i
              className="fa fa-exclamation-triangle"
              style={{ marginLeft: "5px" }}
            ></i>
          </span>
        );
      } else if (daysLeft <= 90) {
        return (
          <span style={{ color: "orange" }}>
            {formattedDate}
            <i
              className="fa fa-exclamation-triangle"
              style={{ marginLeft: "5px" }}
            ></i>
          </span>
        );
      }
      return <span style={{ color: "black" }}>{formattedDate}</span>;
    },
  },
  {
    dataField: "status",
    text: "Status",
    sort: true,
    headerStyle: headerStyle,
  },
];

export const sorting = [
  {
    dataField: "vendorName",
    order: "asc",
  },
];
